// Past this, carriers' bills of lading shrink the reference to fit its box,
// down to unreadable on the tightest ones.
export const REFERENCE_NUMBER_READABLE_MAX_CHARS = 30;

export function referenceNumbersIsTooLongForBol(
  referenceNumber: string | undefined,
): boolean {
  return (
    (referenceNumber ?? "").trim().length > REFERENCE_NUMBER_READABLE_MAX_CHARS
  );
}
